import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.scss";
import ROUTES from "./routes/routes";
import { AuthProvider } from "./context/AuthContext";
import { CurrenciesProvider } from "./context/CurrenciesContext";
import { BasketWishlistProvider } from "./context/BasketWishlistContext";
import { Toaster } from "sonner";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import "./i18n";

const router = createBrowserRouter(ROUTES, {
  future: {
    v7_relativeSplatPath: true,
    v7_normalizeFormMethod: true,
    v7_fetcherPersist: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  } as any,
});

const ThemedToaster = () => {
  const { theme } = useTheme();

  return (
    <Toaster
      theme={theme}
      richColors
      duration={2000}
      position="top-right"
      closeButton
    />
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CurrenciesProvider>
          <BasketWishlistProvider>
            <RouterProvider router={router} unstable_useTransitions={false} />
            <ThemedToaster />
          </BasketWishlistProvider>
        </CurrenciesProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
